// create subaccount
export const CREATE_SUBACCOUNT_STARTED = "CREATE_SUBACCOUNT_STARTED";
export const CREATE_SUBACCOUNT_SUCCESS = "CREATE_SUBACCOUNT_SUCCESS";
export const CREATE_SUBACCOUNT_FAILED = "CREATE_SUBACCOUNT_FAILED";

// fetch subaccounts
export const GET_SUBACCOUNT_STARTED = "GET_SUBACCOUNT_STARTED";
export const GET_SUBACCOUNT_SUCCESS = "GET_SUBACCOUNT_SUCCESS";
export const GET_SUBACCOUNT_FAILED = "GET_SUBACCOUNT_FAILED";

// close subaccounts
export const CLOSE_SUBACCOUNT_STARTED = "CLOSE_SUBACCOUNT_STARTED";
export const CLOSE_SUBACCOUNT_SUCCESS = "CLOSE_SUBACCOUNT_SUCCESS";
export const CLOSE_SUBACCOUNT_FAILED = "CLOSE_SUBACCOUNT_FAILED";

// get single subaccount details
export const SET_SUBACCOUNT_DETAILS = "SET_SUBACCOUNT_DETAILS";

// fetch subaccount balance

export const GET_SUBACCOUNT_BALANCE_STARTED = "GET_SUBACCOUNT_BALANCE_STARTED";
export const GET_SUBACCOUNT_BALANCE_SUCCESS = "GET_SUBACCOUNT_BALANCE_SUCCESS";
export const GET_SUBACCOUNT_BALANCE_FAILED = "GET_SUBACCOUNT_BALANCE_FAILED";
